'use client'
import { Wallet } from '@dynamic-labs/wallet-connector-core';

class FlowWallet extends Wallet {
}

export { FlowWallet };
